import { createPlaceholderProfilePicture } from "../Avatar/Avatar.utils";

export function mapCampaignMembers(members) {
  return members.map((member) => {
    return {
      ...member,
      profilePicture:
        member.profilePicture ??
        createPlaceholderProfilePicture({ name: member.firstName, last: member.lastName })
    };
  });
}
